export default {
  components: {},
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  }
};